export default __webpack_public_path__ + "static/media/accounting_point_9_vn_mobile.b98e7d98.png";